import { takeEvery } from "redux-saga/effects";
import {
  addCourseToCartAction,
  addOrderAction,
  deleteItemFromCartAction,
  getCartAction,
  getDetailOrderAction,
  handleCartAction,
} from "./slices";
import {
  addCourseToCartWorker,
  addOrderWorker,
  deleteItemFromCartWorker,
  getCartWorker,
  getDetailOrderWorker,
  handleCartWorker,
} from "./workers";

const ordersWatcher = [
  takeEvery(addCourseToCartAction, addCourseToCartWorker),
  takeEvery(getCartAction, getCartWorker),
  takeEvery(deleteItemFromCartAction, deleteItemFromCartWorker),
  takeEvery(handleCartAction, handleCartWorker),
  takeEvery(addOrderAction, addOrderWorker),
  takeEvery(getDetailOrderAction, getDetailOrderWorker),
];

export default ordersWatcher;
